import { Form, Input, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import AuthenticationService from "../../Services/AuthenticationService";
import { generateAesKey } from "../../utils/encryptPassword";
import PatientService from "../../Services/PatientService";

function MobNumVerification(props) {
  const [resendBtnClicked, setResendBtnClicked] = useState(false);
  const [isResendEnabled, setIsResendEnabled] = useState(true);
  const [timer, setTimer] = useState(120);
  const [disable, setDisable] = useState(false);
  const patJson = localStorage.getItem("patientData");
  const patObject = patJson ? JSON.parse(patJson) : null;
  const verifyformRef = useRef();
  const inputRefs = useRef([]);

  useEffect(() => {
    if (resendBtnClicked === true) {
      const timerInterval = setInterval(() => {
        setTimer((prevState) => {
          if (prevState === 0) {
            clearInterval(timerInterval);
            setResendBtnClicked(false);
            return 0;
          }
          return prevState - 1;
        });
      }, 1000);
      return () => {
        clearInterval(timerInterval);
        setTimer(120);
      };
    }
  }, [resendBtnClicked]);

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) && index < 5) {
      inputRefs.current[index + 1].focus();
    } else if (!e.target.value && index >= 1) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleResend = async (e) => {
    e.preventDefault();
    setIsResendEnabled(false);
    setResendBtnClicked(true);
    setTimeout(() => {
      setIsResendEnabled(true);
    }, 180000);

    const payload = {
      patientId: patObject.patientId,
      mobileNumber: props.mobNum,
      status: 1,
    };

    try {
      await AuthenticationService.patientMobNumChangeOtp(payload);
    } catch (e) {
      console.error(e);
      message.error("Something went wrong. Please try again later.");
    }
  };

  const handleOtpVerification = async (e) => {
    e.preventDefault();
    setDisable(true);
    const { one, two, three, four, five, six } =
      verifyformRef.current.getFieldsValue();
    let finalNum = one + two + three + four + five + six;
    const encryptPassword = generateAesKey(finalNum);

    const payload = {
      numVal: encryptPassword,
      patientId: patObject.patientId,
    };

    const patPayload = {
      ...patObject,
      mobile: props.mobNum,
    };

    try {
      const response = await AuthenticationService.patientMobNumVerifyOtp(
        payload
      );
      if (response.data === 1) {
        const patResponse = await PatientService.patientUpdate(patPayload);
        if (patResponse.data === 1) {
          message.success("Patient Mobile number updated successfully.", 4);
          props.PatientDetail();
          props.handleModalClose();
        }
        setDisable(false);
      }
    } catch (e) {
      console.error(e);
      setDisable(false);
      message.error(e.response?.data?.message);
    }
  };

  return (
    <div className="p-2">
      <div>
        <label className="text-lg font-medium">OTP </label>
        <span style={{ color: "#FF000F" }}>*</span>
      </div>
      <Form ref={verifyformRef}>
        <div className="w-full flex gap-2 items-center justify-evenly">
          {[...Array(6)].map((_, index) => (
            <Form.Item
              key={index}
              name={["one", "two", "three", "four", "five", "six"][index]}
              className="w-1/5"
              rules={[
                {
                  pattern: /^[0-9]{1}$/,
                },
              ]}
            >
              <Input
                maxLength={1}
                ref={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => handleInputChange(e, index)}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                className="outline-none border rounded-lg border-borderColor p-3 text-center font-medium text-xl"
              />
            </Form.Item>
          ))}
        </div>
      </Form>
      <div className="flex items-center justify-end gap-2">
        <button
          className={`w-full p-2 bg-lightBlue rounded-lg font-semibold disabled:cursor-not-allowed`}
          disabled={!isResendEnabled}
          onClick={handleResend}
        >
          Resend {resendBtnClicked ? `(${timer})` : null}
        </button>
        <button
          disabled={disable}
          className="w-full p-2 bg-primaryColor text-white rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={handleOtpVerification}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default MobNumVerification;
